import React from 'react';
import GenericFormWithChildQuestions from '../genericFormWithChildrenQuestions/genericFormWithChildQuestion';
import { ObjectOfAny, QuestionSchema } from '../../reducers/types';
import GenericParentQuestion from '../genericFormWithChildrenQuestions/genericParentQuestion';
import { useTranslation } from 'react-i18next';

const WithdrawClaimApplicationForm = (props: {
    questionTypes: any;
    withDrawQuestions: any;
    claimReference?: string;
}): JSX.Element => {
    const { questionTypes, withDrawQuestions } = props;
    const { t } = useTranslation();
    return (
        <div className={'row'}>
            <div className="col-sm-12">
                {t<string>('withdrawClaimApplicationTitle')}
            </div>
            <GenericFormWithChildQuestions>
                {withDrawQuestions.map(
                    (
                        question: QuestionSchema | any,
                        index: number,
                        accQuestions: QuestionSchema[],
                    ) => {
                        if (question.isParent) {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericParentQuestion.Form
                                            index={index}
                                            key={question.id}
                                            question={question}
                                            accQuestions={accQuestions}
                                            questionTypes={
                                                questionTypes as ObjectOfAny
                                            }
                                            notUseFieldValidator={false}
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        } else {
                            return (
                                <GenericFormWithChildQuestions.ParentElement
                                    key={question.id}
                                >
                                    <>
                                        <GenericFormWithChildQuestions.ChildrenElement
                                            key={question.id}
                                            question={question}
                                            questions={withDrawQuestions}
                                            questionTypes={questionTypes}
                                            notUseFieldValidator={false}
                                            defaultLabelSize={'col-sm-12'}
                                            defaultInputSize={'col-sm-12'}
                                        />
                                    </>
                                </GenericFormWithChildQuestions.ParentElement>
                            );
                        }
                    },
                )}
            </GenericFormWithChildQuestions>
        </div>
    );
};

export default WithdrawClaimApplicationForm;
